import React from 'react';
import PropTypes from 'prop-types';
import './chooseQuantityFlavorTile.scss';
export default function ChooseQuantityFlavorTile(_ref) {
  var productVariant = _ref.productVariant,
      quantity = _ref.quantity,
      onQuantityChange = _ref.onQuantityChange,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
      _ref$fallbackImage = _ref.fallbackImage,
      fallbackImage = _ref$fallbackImage === void 0 ? null : _ref$fallbackImage;
  var _productVariant$featu = productVariant.featured_image_thumbnail;
  _productVariant$featu = _productVariant$featu === void 0 ? {} : _productVariant$featu;
  var _productVariant$featu2 = _productVariant$featu.src,
      imgSrc = _productVariant$featu2 === void 0 ? fallbackImage : _productVariant$featu2;

  function handleIncreaseQuantity() {
    if (onQuantityChange) {
      onQuantityChange(productVariant, quantity + 1);
    }
  }

  function handleDecreaseQuantity() {
    if (quantity > minValue && onQuantityChange) {
      onQuantityChange(productVariant, quantity - 1);
    }
  } // Sold out tile


  if (productVariant.metafields && productVariant.metafields.soldOut) {
    return /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__flavorContainer btFlavorSelector__flavorContainer--disabled"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__flavorThumbnail btFlavorSelector__flavorThumbnail--opaque_img"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "",
      src: imgSrc
    })), /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__flavorQuantityWrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__flavorTitle"
    }, /*#__PURE__*/React.createElement("h4", null, productVariant.title, /*#__PURE__*/React.createElement("span", {
      className: "soldOutText"
    }, /*#__PURE__*/React.createElement("br", null), " Sold out"))), /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__quantityUpDown"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: "Decrease ".concat(productVariant.title, " quantity"),
      className: "btFlavorSelector__button btFlavorSelector__button--minus btFlavorSelector__button--disabled"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-minus-circle"
    })), /*#__PURE__*/React.createElement("span", {
      id: "bt-fs-quantity-".concat(productVariant.id),
      "aria-label": "".concat(productVariant.title, " quantity"),
      className: "btFlavorSelector__selectedQuantity"
    }, quantity), /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: "Decrease ".concat(productVariant.title, " quantity"),
      className: "btFlavorSelector__button btFlavorSelector__button--plus btFlavorSelector__button--disabled"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-plus-circle"
    }))), /*#__PURE__*/React.createElement("p", null, "Quantity"))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__flavorContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__flavorThumbnail"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: imgSrc
  })), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__flavorQuantityWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__flavorTitle"
  }, /*#__PURE__*/React.createElement("h4", null, productVariant.title)), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__quantityUpDown"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    title: "Decrease ".concat(productVariant.title, " quantity"),
    className: "btFlavorSelector__button btFlavorSelector__button--minus",
    onClick: handleDecreaseQuantity
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-minus-circle"
  })), /*#__PURE__*/React.createElement("span", {
    id: "bt-fs-quantity-".concat(productVariant.id),
    "aria-label": "".concat(productVariant.title, " quantity"),
    className: "btFlavorSelector__selectedQuantity"
  }, quantity), /*#__PURE__*/React.createElement("button", {
    type: "button",
    title: "Decrease ".concat(productVariant.title, " quantity"),
    className: "btFlavorSelector__button btFlavorSelector__button--plus",
    onClick: handleIncreaseQuantity
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus-circle"
  }))), /*#__PURE__*/React.createElement("p", null, "Quantity"))));
}
ChooseQuantityFlavorTile.propTypes = {
  productVariant: PropTypes.object.isRequired,
  quantity: PropTypes.number.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  fallbackImage: PropTypes.string,
  minValue: PropTypes.number
};